<!--  -->
<template>
  <div class="v-a">
    <slot />
  </div>
</template>

<script>
export default {
  name: "A",
  data() {
    return {};
  }
};
</script>
<style lang='stylus' scoped></style>
